import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box } from 'components/ui';
import { colors } from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import ChangeMethodEN from 'components/RwdBasket/Carts/CartLayout/SkuItem/ChangeMethod/locales/ChangeMethod_en_US';
import ChangeMethodFR from 'components/RwdBasket/Carts/CartLayout/SkuItem/ChangeMethod/locales/ChangeMethod_fr_CA';

const { getLocalisedDataFromResource } = localeUtils;

function ChangeMethodVariantBox({ availableForOnlyOneOption }) {
    const getText = getLocalisedDataFromResource(ChangeMethodEN, ChangeMethodFR);

    return (
        <Box
            paddingY={2}
            paddingX={3}
            fontSize={'sm'}
            borderRadius={2}
            backgroundColor={colors.nearWhite}
            textAlign={'left'}
            children={getText(availableForOnlyOneOption ? 'availableForOne' : 'availableForSomeButNotAll')}
        />
    );
}

export default wrapFunctionalComponent(ChangeMethodVariantBox, 'ChangeMethodVariantBox');
